import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../core/service/auth.service';
import { AlertsService } from '../../../shared/service/alerts.service';
import { StorageService } from '../../../shared/service/storage.service';
import { } from 'googlemaps'
import moment from 'moment';
var map, tripid, directionDisplay, directionsService, stepDisplay, marker, position;
var infowindow = new google.maps.InfoWindow();
declare function JS_ReverseGeocoding(arg1, arg2, arg3);
declare var $, Swal;
var script;
var markerArray = [];
var line = [];
var polylineCoordinates = [];
var polyline = null;
@Component({
  selector: 'app-freetrack',
  templateUrl: './freetrack.component.html',
  styleUrls: ['./freetrack.component.scss']
})
export class FreetrackComponent implements OnInit, AfterViewInit, OnDestroy {
  token;
  tripID = "";
  deviceID = "";
  _id = ""
  trip;
  asset;
  redis;
  geofences = [];
  constructor(private router: Router, private storage: StorageService, private alert: AlertsService, private api: AuthService, private route: ActivatedRoute) {
    // if(localStorage.getItem(environment.tokenKey))
    // {
    //   this.token = JSON.parse(atob((localStorage.getItem(environment.tokenKey)).split('.')[1])).token
    // }

    this.route.queryParams.subscribe(params => {
      if (params.tripID == undefined || params.id == undefined) {
        this.tripID = "";
        this.deviceID = "";
        this._id = "";
        this.router.navigate(['dashboard']);
        return
      }
      else {
        this.tripID = params.tripID;
        this.deviceID = params.id;
        this._id = params._id;
      }
    });
  }

  ngOnInit(): void {

  }

  initMap() {
    infowindow = new google.maps.InfoWindow();
    var myOptions =
    {
      zoom: 7,
      center: new google.maps.LatLng(22.570750, 88.353150),
      mapTypeControlOptions: { position: google.maps.ControlPosition.LEFT_BOTTOM },
      fullScreenControl: false,
      streetViewControl: false,
      scaleControl: true,
    };
    map = new google.maps.Map(document.getElementById("map"), myOptions);
    var trafficLayer = new google.maps.TrafficLayer();
    trafficLayer.setMap(map);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.initMap();
      this.getTrackData();
    }, 1000)
  }

  getTrackData() {
    this.api.getTrackDataWithoutLogin({ _id: this._id, tripID: this.tripID, id: this.deviceID }).subscribe((res: any) => {
      const { success, data, message } = res
      if (success) {
        this.plotMap(res);
      }
      else {
        this.alert.showToast(message, 'error')
      }
    }, (err) => this.alert.showToast(err.message, 'error'))
  }

  plotMap(data) {
    const { track, trip, redis, asset } = data;
    this.asset = asset;

    this.trip = trip;

    this.clearResources();

    if (trip.geofence[0].id) {
      this.getList({ "searchType": '_id', "searchValue": trip.geofence[0].id });
    }

    if (trip.geofence[0]._id) {
      this.getList({ "searchType": '_id', "searchValue": trip.geofence[0]._id });
    }

    if (trip.geofence[1].id) {
      this.getList({ "searchType": '_id', "searchValue": trip.geofence[1].id });
    }

    if (trip.geofence[1]._id) {
      this.getList({ "searchType": '_id', "searchValue": trip.geofence[1]._id });
    }

    var point1 = new google.maps.LatLng(track[0].latitude, track[0].longitude);
    var point2 = new google.maps.LatLng(track[0].latitude, track[0].longitude);

    if (track[track.length - 1].latitude) {
      var bounds = new google.maps.LatLngBounds();
      bounds.extend(new google.maps.LatLng(track[0].latitude, track[0].longitude));
      var myPlace = new google.maps.LatLng(track[track.length - 1].latitude, track[track.length - 1].longitude);
    }
    else {
      var bounds = new google.maps.LatLngBounds();
      bounds.extend(new google.maps.LatLng(track[0].lat, track[0].lng));
      var myPlace = new google.maps.LatLng(track[track.length - 1].lat, track[track.length - 1].lng);
    }

    bounds.extend(myPlace);
    map.fitBounds(bounds);

    google.maps.event.trigger(map, "resize");
    google.maps.event.trigger(map, "refresh");

    this.clearResources();
    markerArray = [];
    line = [];
    polylineCoordinates = [];
    polyline = null;

    for (let index = 0; index < track.length; index++) {
      const v = track[index];
      this.addMarkerWithPolyline(v, index);
    }
  }

  addMarkerWithPolyline(v, index) {
    marker = new google.maps.Marker(
      {
        position: new google.maps.LatLng(v.latitude, v.longitude),
        icon:
        {
          url: v.icon,
          scaledSize: new google.maps.Size(v.size, v.size),
        },
        optimized: false,
        map: map,
      });
    markerArray.push(marker);
    polylineCoordinates.push(marker.getPosition());
    this.drawLiveTrackPolyLine();

    google.maps.event.addListener(marker, 'click', (function (v, marker, infowindow) {
      return function () {
        // console.log(v);
        var dateInlocal = moment(v.packet_time).format("DD-MM-YYYY HH:mm:ss");
        var speedNew = parseFloat(v.speed).toFixed(2)

        var l_s_infoWindowContent = "<div class='infowindowcontent z-depth' style='font-weight:bold;width:290px'> <div style='width:8%;float:left'> <span style='font:bold;' style='color: #ef940e'> <i class='fa fa-clock-o' style='color: #ef940e'></i> </span> </div> <div style='width:25%;float:left'> <span>DateTime:</span> </div> <div style='width:67%;float:left'> <span>" + dateInlocal + "</span> </div> <div style='width:8%;float:left'> <span style='font:bold;'> <i class='fa fa-bolt' style='color: #ef940e'></i> </span> </div> <div style='width:25%;float:left'> <span>Speed:</span> </div> <div style='width:67%;float:left'> <span>" + speedNew + " km/h</span> </div> <div style='width:8%;float:left'> <span style='font:bold;'> <i class='fa fa-lock' style='color: #ef940e'></i> </span> </div> <div style='width:25%;float:left'> <span>Event:</span> </div> <div style='width:67%;float:left'> <span>" + capitalize(v.eventO) + "</span> </div> <div style='width:8%;float:left'> <span style='font:bold;'> <i class='fa fa-lock' style='color: #ef940e'></i> </span> </div> <div style='width:25%;float:left'> <span>Status:</span> </div> <div style='width:67%;float:left'> <span>" + capitalize(v.statusO) + "</span> </div>      <div style='width:8%;float:left'> <span style='font:bold;'> <i class='fa fa-home' style='color: #ef940e'></i> </span> </div> <div style='width:25%;float:left'> <span>Address:</span> </div> <div style='width:67%;float:left'> <span> <img onload='JS_ReverseGeocoding(" + parseFloat(v.latitude).toFixed(5) + "," + parseFloat(v.longitude).toFixed(5) + ",this)' src='assets/img/loadingondashboardgrid.gif'/></span></div></div>";

        infowindow.setContent(l_s_infoWindowContent);

        infowindow.open(map, marker);

        var latLng = new google.maps.LatLng(v.latitude, v.longitude);

        map.panTo(latLng);

        map.panBy(0, 30);
      };
    })(v, marker, infowindow));
  }

  drawLiveTrackPolyLine() {
    var l_o_lineSymbol =
    {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW
    };

    polyline = new google.maps.Polyline(
      {
        path: polylineCoordinates,
        geodesic: true,
        strokeColor: '#202f4d',
        strokeOpacity: 1.0,
        strokeWeight: 2,
        icons: [
          {
            icon: l_o_lineSymbol,
            offset: '0',
          }]
      });

    polyline.setMap(map);
    line.push(polyline);
  }

  getList(obj) {
    this.api.getGeofenceWithoutLogin(obj).subscribe((res: any) => {
      const { success, data, count, message } = res
      if (success) {
        if (data[0].overlayType == 'polygon') {
          var polygonarray = [];
          for (let index = 0; index < data[0].geofence.coordinates[0].length; index++) {
            var d = data[0].geofence.coordinates[0][index];
            polygonarray.push({ lat: d[1], lng: d[0] })
          }

          new google.maps.Polygon(
            {
              paths: polygonarray,
              strokeColor: "#FF0000",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#f57c00",
              fillOpacity: 0.35,
              map,
            })
        }
        else {
          new google.maps.Circle(
            {
              strokeColor: "#FF0000",
              strokeOpacity: 0.8,
              strokeWeight: 2,
              fillColor: "#f57c00",
              fillOpacity: 0.35,
              map,
              center: { lat: data[0].coordinates[0], lng: data[0].coordinates[1] },
              radius: Number(data[0].radius),
            });
        }
      }
      else {
        // this.alert.showToast(message, 'error')
      }
    }, (err) => this.alert.showToast(err.message, 'error'))
  }

  clearResources() {
    if (marker) {
      marker.setMap(null);
    }
    if (markerArray.length != 0) {
      for (var i = 0; i < markerArray.length; i++) {
        markerArray[i].setMap(null);
        polyline.getPath().removeAt(i);
      }
      markerArray = [];
    }
    if (polyline) {
      polyline.setMap(null);
    }
    if (polylineCoordinates.length != 0) {
      polylineCoordinates = [];
    }
    if (line.length != 0) {
      for (i = 0; i < line.length; i++) {
        line[i].setVisible(false);
        line[i].setMap(null);
      }
      line = [];
    }

  }

  ngOnDestroy(): void {
    this.clearResources();
    if (script) {
      script.remove()
    }
  }

}


function capitalize(string) {
  if (string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  else {
    return "NA";
  }
}